module.exports = __webpack_public_path__ + "static/media/Accountability_Sign.f45b8bb8.png";